export default function handleVoidBOLResponseNotification(
	rootstore,
	response,
	fulfillmentOrderId,
	voidOnCarrierOrChannel = true
) {
	if (response) {
		if (response.cancelledShipment) {
			if (response.voidedInternally) {
				rootstore.notificationStore.success(['VOIDBOLVIEW.SUCCESS', { id: fulfillmentOrderId }]);
			} else {
				// Voided on Carrier/Channel but failed to void internally
				rootstore.notificationStore.warning(['VOIDBOLVIEW.CARRIERSUCCESS', { id: fulfillmentOrderId }]);
			}
		} else {
			if (response.voidedInternally) {
				if (voidOnCarrierOrChannel) {
					// Voided Internally but failed to void on carrier/channel
					rootstore.notificationStore.warning([
						'VOIDBOLVIEW.ERRORONAPI',
						{ id: fulfillmentOrderId, notification: response.message },
					]);
				} else {
					// Void on channel was not selected
					rootstore.notificationStore.success(['VOIDBOLVIEW.SUCCESS', { id: fulfillmentOrderId }]);
				}
			} else {
				// Failed to void on Carrier/Channel and Internally
				rootstore.notificationStore.error(['VOIDBOLVIEW.ERROR', { id: fulfillmentOrderId }]);
			}
		}
	} else {
		rootstore.notificationStore.error(['VOIDBOLVIEW.ERROR', { id: fulfillmentOrderId }]);
	}
}
